import { isNil } from 'lodash';

export default function buildPlaybookOutputGate({ pipelineOutput, canTransformEvent }) {
  const disabled = isNil(pipelineOutput.outputEvent) || !canTransformEvent;

  let tooltip;
  if (isNil(pipelineOutput.outputEvent)) {
    tooltip = 'Pipeline Output is required';
  } else if (!canTransformEvent) {
    tooltip = 'You do not have permission to transform events';
  }

  return { disabled, tooltip };
}
